var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"quote-container mb-0 p-3"},[_c('blockquote',{staticClass:"quote"},[_vm._t("quote")],2),_c('figcaption',{staticClass:"attribution text-right"},[_vm._t("attribution")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }